import { NavLink } from 'react-router-dom';
import { Home, BookOpen, Radio, Users } from 'lucide-react';
import { useState } from 'react';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false); // State to toggle sidebar visibility

  // Style for active and inactive NavLinks
  const getLinkStyles = ({ isActive }) => {
    return `flex items-center gap-3 p-3 rounded-lg transition-all duration-200 ${
      isActive 
        ? 'bg-blue-100 text-blue-700 font-medium' 
        : 'text-gray-700 hover:bg-gray-100'
    }`;
  };

  return (
    <>


      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full bg-white shadow-md p-4 z-40 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0 lg:static lg:w-58`}
      >
        <div className="mb-4">
          <h2 className="text-lg font-bold text-gray-700">เมนู</h2>
        </div>

        <nav className="flex flex-col gap-2">
          <NavLink to="/panel" className={getLinkStyles} end>
            <Home size={20} />
            <span>แดชบอร์ด</span>
          </NavLink>

          <NavLink to="/panel/course" className={getLinkStyles}>
            <BookOpen size={20} />
            <span>หลักสูตรอบรม</span>
          </NavLink>

          <NavLink to="/panel/channel" className={getLinkStyles}>
            <Radio size={20} />
            <span>ช่องทางการรับรู้</span>
          </NavLink>

          <NavLink to="/panel/employee" className={getLinkStyles}>
            <Users size={20} />
            <span>ข้อมูลพนักงาน</span>
          </NavLink>
        </nav>

        <div className="mt-auto pt-6 border-t border-gray-200 mt-6">
          <p className="text-sm text-gray-500 ">©2025 เอไอ บิสซิเนส เทคโนโลยี </p>
        </div>
      </aside>

      {/* Overlay for Mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </>
  );
};

export default Sidebar;